import FeatherIcon from 'feather-icons-react';
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AuthService from 'services/auth.service';
import FormResultMessage from './FormResultMessage';

interface UpdatePasswordFormProps {
  id: number;
}

const UpdatePasswordForm: React.FC<UpdatePasswordFormProps> = ({ id }) => {
  const [message, setMessage] = useState<string | null>(null);
  const [messageType, setMessageType] = useState<
    'successupdate' | 'errorupdate'
  >('successupdate');
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [logout, setlogout] = useState<boolean>(false);

  const [showOldPassword] = useState(false);
  const [showPassword] = useState(false);
  const [showRepeatPassword] = useState(false);

  //To check information registered
  const formik = useFormik({
    initialValues: {
      oldpassword: '',
      password: '',
      repeatpassword: ''
    },
    validationSchema: Yup.object({
      oldpassword: Yup.string().required('Password is required'),
      password: Yup.string()
        .min(10, 'Password must be at least 10 characters')
        .required('Password is required'),
      repeatpassword: Yup.string()
        .oneOf([Yup.ref('password')], 'New Passwords must match')
        .required('Password is required')
    }),
    onSubmit: async values => {
      try {
        await AuthService.updatepassword({
          id: id,
          oldpassword: values.oldpassword,
          password: values.password
        });
        setlogout(true);
        setMessage('Password has been updated!');
        setMessageType('successupdate');
      } catch (error) {
        setMessage('I apologize, but it seems there was a hiccup! ' + error);
        setMessageType('errorupdate');
      }
      setModalVisible(true);
    }
  });

  const closeModal = () => {
    setModalVisible(false);
  };

  return (
    <div>
      <h4 className="text-body-highlight text-center">Change your password</h4>
      <p className="text-body-tertiary  text-center">Type your new password</p>
      <div className="p-4 pb-6">
        <form className="mb-0 pb-0" onSubmit={formik.handleSubmit}>
          <div>
            <label className="form-label">Old Password</label>
            <input
              type={showOldPassword ? 'text' : 'password'}
              name="oldpassword"
              value={formik.values.oldpassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control"
            />
            {formik.touched.oldpassword && formik.errors.oldpassword ? (
              <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
                {formik.errors.oldpassword}
              </div>
            ) : null}
          </div>
          <br />
          <div>
            <label className="form-label">New Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control"
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
                {formik.errors.password}
              </div>
            ) : null}
          </div>
          <div>
            <label className="form-label">Confirm New Password</label>
            <input
              type={showRepeatPassword ? 'text' : 'password'}
              name="repeatpassword"
              value={formik.values.repeatpassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-control"
            />
            {formik.touched.repeatpassword && formik.errors.repeatpassword ? (
              <div className="alert phoenix-primary text-primary p-0 fs-9 text-end">
                {formik.errors.repeatpassword}
              </div>
            ) : null}
          </div>
          <div className="text-center pt-4">
            <button type="submit" className="btn btn-primary btn-block">
              <FeatherIcon icon="key" className="me-2" size={18} />
              Update Your Password
            </button>
          </div>
        </form>
        <FormResultMessage
          show={modalVisible}
          message={message}
          messageType={messageType}
          logout={logout}
          onClose={closeModal}
        />
      </div>
    </div>
  );
};

export default UpdatePasswordForm;
